module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_vm._m(0), _c('br'), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('select-year', {
    attrs: {
      "back": 7
    },
    model: {
      value: (_vm.year),
      callback: function($$v) {
        _vm.year = $$v
      },
      expression: "year"
    }
  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("New Revenue: "), _c('b', [_vm._v(_vm._s(_vm.year))])]), _vm._v(" "), _c('pie-chart', {
    attrs: {
      "data": _vm.chartRevenue,
      "thousands": ",",
      "legend": "right",
      "colors": _vm.colours,
      "download": true
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("New Revenue: "), _c('b', [_vm._v(_vm._s(_vm.year))])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.revenue,
      "border": "",
      "stripe": "",
      "show-summary": "",
      "sum-text": "Totals",
      "summary-method": _vm.summaryFormatter
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "period",
      "label": "Period"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sites",
      "label": "Sites",
      "formatter": _vm.formatInt
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ways",
      "label": "Ways",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatInt
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fees",
      "label": "Fees",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatNum
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "capex",
      "label": "CAPEX",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatNum
    }
  })], 1), _vm._v(" "), _c('hr')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" New Revenue Report")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee4bb3f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/finance/RevenueReport.vue
// module id = 1736
// module chunks = 0